/**
 * Tarayıcı bağlamı (eski istemciden): `pwa` (ana ekrana eklenmiş), `ios-webview`, `android-webview`, `browser`,
 * `unknown`. Tanı kaydında ve iOS'ta anlık bildirim yönergesinde kullanılır (iOS web push yalnız ana ekrana
 * eklenmiş uygulamada çalışır).
 */
export type BrowserContext = 'pwa' | 'ios-webview' | 'android-webview' | 'browser' | 'unknown';

export function getBrowserContext(): BrowserContext {
  try {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches) {
      return 'pwa';
    }
  } catch {
    // Tanı engellenemez.
  }

  const ua = typeof navigator === 'undefined' ? '' : (navigator.userAgent ?? '');
  if (!ua) {
    return 'unknown';
  }

  if (/iPhone|iPad|iPod/.test(ua) && !ua.includes('Safari/')) {
    return 'ios-webview';
  }

  if (ua.includes('; wv)')) {
    return 'android-webview';
  }

  return 'browser';
}

/** iPhone ya da iPad (iPadOS masaüstü kimliğiyle gelir: dokunmatik Mac). */
export function isIos(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent ?? '';
  return /iPhone|iPad|iPod/.test(ua) || (ua.includes('Macintosh') && (navigator.maxTouchPoints ?? 0) > 1);
}

const PROBE_KEY = 'ticarishift.storageProbe';

/**
 * Tarayıcı deposu yazılıp okunabiliyor mu. Gizli sekme ya da engellenmiş depolamada `false`: hatırlanan tercihler
 * yalnız bu sekmede geçerlidir (oturum açma ekranındaki tek satırlık uyarı).
 */
export function isStoragePersistent(): boolean {
  try {
    localStorage.setItem(PROBE_KEY, '1');
    const ok = localStorage.getItem(PROBE_KEY) === '1';
    localStorage.removeItem(PROBE_KEY);
    return ok;
  } catch {
    return false;
  }
}
